export function getClasses ({ fanLevelClasses, key, extraClasses })
{
	let classes = extraClasses || [];

	if (fanLevelClasses[key])
	{
		classes.push(fanLevelClasses[key]);
	}

	if (fanLevelClasses)
	{
		const keys = _.keys(fanLevelClasses);

		if (_.first(keys) !== key)
		{
			classes.push('slide-in-covered');
		}
	}

	return classes;
}
